const HomeTranslationFr = {
    legal_terms: 'Mentions légales',
    privacy_policy: 'Politique de confidentialité',
    terms_of_service: `Conditions générales d'utilisation`,
    contact: 'Contact',
};

export default HomeTranslationFr;
  